<atlas-single-button-dialog
  [buttonText]="closeText"
  [headerText]="data.headerText"
>
  <atlas-swap-library-form
    formContent
    [userLibraries]="userLibraries"
    (switchClicked)="onSwitchClicked($event)"
    [currentLibraryId]="data.currentLibraryId"
    (deleteClicked)="onDeleteClicked($event)"
  ></atlas-swap-library-form>
</atlas-single-button-dialog>
